<template>
  <component
    v-if="wallet"
    :is="componentMap[wallet.name]"
    :wallet="wallet"
    :project="project"
    @next="onAddressSelected"
    @onError="onError"
    @cancel="cancel"
  />
</template>

<script>
import Torus from "./Torus";
import Fortmatic from "./Fortmatic";
import Metamask from "./Metamask";
import Ledger from "./Ledger";
import ImToken from "./ImToken";
import WalletConnect from "./WalletConnect";
import Keystation from "./Keystation";
import Keplr from "./Keplr";
import Terrastation from "./Terrastation";
import Gnosis from "./Gnosis";
import Trezor from "./Trezor";
import MetamaskEvmos from "./MetamaskEvmos";
import Phantom from "./Phantom";
import Martian from "./Martian";
import Leap from "./Leap";

export default {
  name: "GetWalletAddress",
  components: {
    Torus,
    Fortmatic,
    Metamask,
    Ledger,
    ImToken,
    WalletConnect,
    Keystation,
    Keplr,
    Terrastation,
    Gnosis,
    Trezor,
    MetamaskEvmos,
    Phantom,
    Martian,
    Leap,
  },
  props: {
    wallet: {
      type: Object,
    },
    project: {
      type: Object,
    },
  },
  data: () => ({
    componentMap: {
      torus: "Torus",
      fortmatic: "Fortmatic",
      metamask: "Metamask",
      ledger: "Ledger",
      imtoken: "ImToken",
      walletconnect: "WalletConnect",
      keystation: "Keystation",
      keplr: "Keplr",
      terrastation: "Terrastation",
      gnosis: "Gnosis",
      trezor: "Trezor",
      metamaskEvmos: "MetamaskEvmos",
      phantom: "Phantom",
      martian: "Martian",
      leap: "Leap",
    },
  }),
  methods: {
    onAddressSelected(address, metadata) {
      this.$emit("onAddressSelected", address, metadata);
    },
    onError(error) {
      this.$emit("onError", error);
    },
    cancel() {
      this.$emit("onCancelled");
    },
  },
};
</script>

<style lang="scss">
.wallet-address {
  .accept-cb {
    label {
      font-size: 14px;
      color: var(--black);
      line-height: 16px;
      letter-spacing: 0.4px;
      font-weight: 400;
    }
  }
  .addresses {
    position: relative;
    .v-radio {
      padding: 4px 8px;
      label {
        color: rgba(0, 0, 0, 0.87);
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.4px;
        line-height: 16px;
      }
    }
    .hd-path-input {
      .v-input__control {
        .v-input__slot {
          height: 40px !important;
          min-height: 40px !important;
          input {
            color: var(--darkgray);
          }
          fieldset {
            border-color: rgba(0, 0, 0, 0.1) !important;
          }
        }
      }
    }
    .custom-address {
      border: 1px solid rgba(0, 0, 0, 0.1) !important;
    }
  }
}
</style>
